import { gql } from '@apollo/client';

export const GRAPH_ANALYTICS = gql`
  query graphAnalytics(
    $aggregate: String!
    $checkboxAggregates: JSON
    $enableInfoOnClick: Boolean
    $graphType: String!
    $graphTypeOptions: [String!]
    $hydrocarbonType: String
    $discountRate: Float
    $portfolios: [JSON!]
    $stacked: Boolean
    $limit: Int
    $sortDirection: String
    $visibleTraces: JSON
  ) {
    graphAnalytics(
      aggregate: $aggregate
      checkboxAggregates: $checkboxAggregates
      enableInfoOnClick: $enableInfoOnClick
      graphType: $graphType
      graphTypeOptions: $graphTypeOptions
      hydrocarbonType: $hydrocarbonType
      discountRate: $discountRate
      portfolios: $portfolios
      stacked: $stacked
      limit: $limit
      sortDirection: $sortDirection
      visibleTraces: $visibleTraces
    ) {
      analytics
      maxY
    }
  }
`;

export const GRAPH_ASSETS_QUERY_NEW = gql`
  query graphAssetsNew(
    $aggregates: [String!]!
    $chartType: String!
    $enableInfoOnClick: Boolean
    $graphType: String!
    $graphTypeOptions: [String!]
    $portfolios: [JSON!]
    $limit: Int
    $sortDirection: String
    $visibleTraces: JSON
  ) {
    graphAssetsNew(
      aggregates: $aggregates
      chartType: $chartType
      enableInfoOnClick: $enableInfoOnClick
      graphType: $graphType
      graphTypeOptions: $graphTypeOptions
      portfolios: $portfolios
      limit: $limit
      sortDirection: $sortDirection
      visibleTraces: $visibleTraces
    ) {
      analytics
      maxY
    }
  }
`;
